import {
  createSlice,
  PayloadAction,
} from "@reduxjs/toolkit";
import { IProductSubCategory, IProductSubCategoryDropdown, IProductSubCategoryState } from "../../../types/subCategory/productSubCategoryInterfaces";



export const initialState: IProductSubCategoryState =
{
  subCategories: [],
  subCategoriesDropdown: [],
  selectedCategoryId: null,
};

export const productSubCategorySlice =
  createSlice({
    name: "productSubCategories",

    initialState,

    reducers: {
      loadingSubCategories: (
        state,
        action: PayloadAction<
          IProductSubCategory[]
        >
      ) => {
        state.subCategories =
          action.payload;
      },

      loadingSubCategoriesDropdown: (
        state,
        action: PayloadAction<
          IProductSubCategoryDropdown[]
        >
      ) => {
        state.subCategoriesDropdown =
          action.payload;
      },

      setSelectedCategory: (
        state,
        action: PayloadAction<number>
      ) => {
        state.selectedCategoryId =
          action.payload;
      },

      addSubCategory: (
        state,
        action: PayloadAction<
          IProductSubCategory
        >
      ) => {
        state.subCategories.push(
          action.payload
        );
      },

      updateSubCategory: (
        state,
        action: PayloadAction<
          IProductSubCategory
        >
      ) => {
        state.subCategories =
          state.subCategories.map(
            (item) =>
              item.id ===
              action.payload.id
                ? action.payload
                : item
          );
      },

      deactivateSubCategory: (
        state,
        action: PayloadAction<{
          id: number;
          status: boolean;
        }>
      ) => {
        state.subCategories =
          state.subCategories.map(
            (item) =>
              item.id ===
              action.payload.id
                ? {
                    ...item,
                    status:
                      action.payload
                        .status,
                  }
                : item
          );
      },
    },
  });

export const {
  loadingSubCategories,
  loadingSubCategoriesDropdown,
  setSelectedCategory,
  addSubCategory,
  updateSubCategory,
  deactivateSubCategory,
} = productSubCategorySlice.actions;

export default productSubCategorySlice.reducer;